/**
 * Asynchronously getthe cart using ther shopify AJAX API.
 * ref: https://shopify.dev/docs/api/ajax/reference/cart#get-locale-cart-js
 */
export const getCart = async () => {
  try {
    const response = await fetch('/cart?view=ajax', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })

    if (!response.ok) {
      console.error('bad request: ', response)
      return null
    }

    return response.json()
  } catch (err) {
    console.error('Error updating the cart. updates: ', updates, ' error: ', err)
    throw new Error(err);
  }
}